import React from 'react';
import { Divider } from '@material-ui/core';

const SpacedDivider = () => <Divider style={{ margin: '1rem 0rem' }} />;

export default SpacedDivider;
